<template>
  <div class="coupon-record">
    <div class="record-card">
      <div class="my-card-title">我的优惠券<em class="num fs24 mgl10 mgr10">{{ total || 0 }}</em>张</div>


      <div class="table-wrap">

        <div class="data-type-wrap">
          <div class="item" @click="changeTab(null)" :class="[listQuery.type == null ? 'active' : '']">全部</div>
          <div class="item" @click="changeTab(0)" :class="[listQuery.type == 0 ? 'active' : '']">未使用</div>
          <div class="item" @click="changeTab(1)" :class="[listQuery.type == 1 ? 'active' : '']">已使用</div>
          <div class="item" @click="changeTab(2)" :class="[listQuery.type == 2 ? 'active' : '']">已过期</div>
        </div>

        <el-table :data="list" v-loading="loading" element-loading-text="给我一点时间" :empty-text="emptyText" border>
          <el-table-column label="优惠券" align="center" width="300">
            <template slot-scope="{row}">
              <div class="flex-xy-center">
                <div class="coupon flex-col"
                  :class="[row.show_status == 0 ? (row.type == 0 ? '' : 'discount') : 'disabled']">
                  <div class="flex-grow-1 flex-row flex-xy-center border">
                    <div class="price">{{ row.type == 0 ? row.price : row.discount }}</div>
                    <div class="units mgt10 mgl5">{{ row.type == 0 ? '元' : '折' }}</div>
                  </div>
                  <div class="desc" v-if="row.amount > 0">满{{ row.amount }}可用</div>
                  <div class="desc" v-else>无门槛使用</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="使用场景" align="center" minWidth="150" prop="use_range_name">

            <template slot-scope="{row}">
              <template v-if="row.use_range_name.length > 0">
                限{{ row.use_range_name.join('、') }}使用
              </template>

              <template v-else>
                全场通用
              </template>
            </template>
          </el-table-column>
          <el-table-column label="有效期" align="center" width="150">

            <template slot-scope="{row}">
              <p>{{ row.start_time }}</p>
              <p>至</p>
              <p>{{ row.end_time }}</p>
            </template>
          </el-table-column>
          <el-table-column label="领取时间" align="center" width="90" prop="create_time">
          </el-table-column>
          <el-table-column label="操作" align="center" width="100" fixed="right">

            <template slot-scope="{row}">
              <span v-if="row.show_status == 0" class="num" @click="goHome(row)">去使用</span>
              <span v-if="row.show_status == 1" class="grey">{{ row.show_status_name }}</span>
              <span v-if="row.show_status == 2" class="grey">{{ row.show_status_name }}</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="flex-row mgt20">
          <div class="flex-grow-1"></div>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCouponList } from "@/api/user";
export default {
  name: 'CouponList',
  components: {

  },
  data() {
    return {
      loading: true,
      emptyText: '暂无数据',
      listQuery: {
        type: null,
        page: 1,
        pagesize: 10
      },
      list: [],
      total: 0,
      activeIndex: 0,
    };
  },
  computed: {

  },
  created() {
    this.getList();
  },
  methods: {
    changeTab(e) {
      this.listQuery.type = e
      this.list = [];
      this.total = 0;
      this.handleFilter()
    },
    // 获取列表
    getList() {
      this.loading = true;
      const _listQuery = Object.assign({}, this.listQuery);
      getCouponList(_listQuery)
        .then((response) => {
          this.list = response.data.list;
          this.total = response.data.count * 1;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    goHome(row) {
      location.href = '/';
    },
    // 查询
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    // 更改每页行数
    handleSizeChange(val) {
      this.listQuery.pagesize = val;
      this.getList();
    },
    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
  }
};
</script>

<style lang="scss" scoped>
.coupon-record {
  width: 100%;
  padding: 25px 0 227px 0;

  .data-type-wrap {
    display: flex;
    align-items: center;
    column-gap: 20px;
    margin-bottom: 27px;

    .active {
      color: #FFFFFF !important;
      background: #00B4E8 !important;
    }

    .item {
      font-size: 16px;
      font-weight: 400;
      color: #00B4E8;
      background: #00b6e81a;
      padding: 7px 30px;
      cursor: pointer;
    }
  }

  .coupon {
    width: 230px;
    height: 104px;
    border-radius: 8px;
    color: #FFF;
    background-color: #FF6666;
    .price {
      font-size: 32px;
    }

    .units {
      font-size: 16px;
    }

    .desc {
      font-size: 16px;
      line-height: 40px;
      height: 40px;
      text-align: center;
    }

    .border {
      border-bottom: 1px solid #FFF;
    }
  
    &.discount {
      background-color: #FABE2A;
    }

    &.disabled {
      background-color: #A7ACB2;
    }
  }

  .record-card {
    background: #FFFFFF;

    .table-wrap {
      padding: 20px 32px;

    }
  }

  .num {
    color: #00B4E8;
    cursor: pointer;
  }

  .grey {
    color: #A7ACB2;
  }
}
</style>
